import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

const useTypingEffect = (text, options = {}) => {
  const {
    typingSpeed = 50,
    cursorBlinkSpeed = 530,
    skipOnInternalNavigation = true,
  } = options;

  const [displayedText, setDisplayedText] = useState("");
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    // Check if this is an internal navigation (user already visited the homepage in this session)
    const hasVisitedHomepage =
      skipOnInternalNavigation &&
      sessionStorage.getItem("homepage_visited") === "true";

    // If internal navigation, show text immediately without typing effect
    if (hasVisitedHomepage) {
      setDisplayedText(text);
      setShowCursor(false);
      return;
    }

    // Mark as visited for future navigations
    if (skipOnInternalNavigation) {
      sessionStorage.setItem("homepage_visited", "true");
    }

    // Start typing effect on first load
    setDisplayedText("");
    setShowCursor(true);

    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex < text.length) {
        setDisplayedText(text.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        // Hide cursor after typing is complete
        setTimeout(() => setShowCursor(false), 500);
      }
    }, typingSpeed);

    return () => clearInterval(typingInterval);
  }, [text, typingSpeed, skipOnInternalNavigation]);

  // Cursor blinking effect
  useEffect(() => {
    if (displayedText === text) return;

    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, cursorBlinkSpeed);

    return () => clearInterval(cursorInterval);
  }, [displayedText, text, cursorBlinkSpeed]);

  return { displayedText, showCursor };
};

export default useTypingEffect;
